export default __webpack_public_path__ + "static/media/branding-black-webfont.324877a8.woff2";